import { render, staticRenderFns } from "./GameAgent.vue?vue&type=template&id=1461bc4a&scoped=true"
import script from "./GameAgent.vue?vue&type=script&lang=js"
export * from "./GameAgent.vue?vue&type=script&lang=js"
import style0 from "./GameAgent.vue?vue&type=style&index=0&id=1461bc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461bc4a",
  null
  
)

export default component.exports